// extracted by mini-css-extract-plugin
module.exports = {"list":"Catalog_list__1hSja","card":"Catalog_card__3hf8C","btns":"Catalog_btns__3_28W","button":"Catalog_button__KxZE8","loader":"Catalog_loader__3Dtza"};